<template>
  <!--点击导入按钮弹出框-->
    <div class="addMarkBox" custom-class="el-dialog--center">
      <el-dialog
        @close="closeDialogFile"
        title="导入"
        :visible.sync="daoruMark"
        :close-on-click-modal="false"
        width="40%"
        center
      >
        <div style="margin: 15px auto" class="el-dialog--center">
          <input
            type="file"
            ref="file"
            accept=".xls, .csv, .xlsx"
            @change="getFile($event)"
          />
        </div>
        <div style="margin: 15px auto" class="el-dialog--center">
          <el-button @click="closeDialogFile">取消</el-button>
          <el-button type="primary" @click="daoruQueding()" :disabled="isDisable1">确定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import { importBusinessManagementGoods } from '@/api/wms-stock'

export default {
  name: 'daoru',
  data () {
    return {
      isDisable1: false,
      file: []
    }
  },
  props: {
    daoruMark: {
      type: Boolean,
      default: false
    },
    markId: {
      type: Number,
    },
  },
  methods: {
    closeDialogFile () {
      this.$refs.file.value = ''
      this.$emit('update:daoruMark', false)
    },
    // 导入-确定
    daoruQueding (event) {
      console.log(this.markId,'markId')
      function extname (filename) {
        if (!filename || typeof filename != 'string') {
          return false
        }
        let a = filename.split('').reverse().join('')
        let b = a.substring(0, a.search(/\./)).split('').reverse().join('')
        return b
      }
      let name = extname(this.file.name)
      if (name == false) {
        this.$alert('文件为空,请选择文件进行导入', '系统提示')
      } else if (name != 'xlsx' && name != 'csv' && name != 'xls') {
        // xls,.csv
        this.$alert('请选择正确的文件格式', '系统提示')
      } else {
        let formData = new FormData()
        let numId = { id: this.markId }
        formData.append('file', this.file)
        formData.append('params', JSON.stringify(numId));
        this.isDisable1 = true
        importBusinessManagementGoods(formData)
          .then((res) => {
            console.log(res)
            // -1 提示错误信息， 0 成功， 1显示导出异常
            // this.daoruMark = false
            this.isDisable1 = false
            this.$message({
              message: res,
              type: 'success'
            })
            this.$parent.searchFn()
            this.$emit('update:daoruMark', false)
          })
          .catch((err) => {
            console.log(err)
            // if (err.code == -1) {
            this.$message({
              message: err.data == null ? err.message : err.data,
              type: 'error'
            })
            this.isDisable1 = false
          })
      }
    },
    getFile: function (event) {
      this.file = event.target.files[0]
    }
  }
}
</script>

<style>

</style>
